export default function CandidateSupportIco() {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 10.5C8.75 9.56812 8.75 9.10218 8.59776 8.73463C8.39477 8.24458 8.00542 7.85523 7.51537 7.65224C7.14782 7.5 6.68188 7.5 5.75 7.5H4.25C3.31812 7.5 2.85218 7.5 2.48463 7.65224C1.99458 7.85523 1.60523 8.24458 1.40224 8.73463C1.25 9.10218 1.25 9.56812 1.25 10.5M7 3.5C7 4.60457 6.10457 5.5 5 5.5C3.89543 5.5 3 4.60457 3 3.5C3 2.39543 3.89543 1.5 5 1.5C6.10457 1.5 7 2.39543 7 3.5Z"
        stroke="#6941C6"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
